<app-nav></app-nav>

<main class="page">

  <section class="head">
    <h1>My <span>Profile</span></h1>
    <p>Show the world who you are. Build your brand. Create opportunities.</p>
  </section>

  <app-profile-nav></app-profile-nav>

  <section class="layout">

    <div class="content">
      <router-outlet></router-outlet>
    </div>

    <aside class="side" *ngIf="loaded">
      <div class="pcard">
        <h2>Profile Completion</h2>

        <div class="comp">
          <div class="ring">
            <svg viewBox="0 0 120 120">
              <circle class="trk" cx="60" cy="60" r="52"></circle>
              <circle class="bar" cx="60" cy="60" r="52"
                      [attr.stroke-dasharray]="circumference"
                      [attr.stroke-dashoffset]="dashOffset"></circle>
            </svg>
            <span>{{ percent }}%</span>
          </div>

          <ul class="checks">
            <li *ngFor="let s of steps">
              <a [routerLink]="s.link" [class.done]="s.done">
                <i class="fa-solid" [ngClass]="s.done ? 'fa-circle-check' : 'fa-circle'"></i>
                {{ s.label }}
              </a>
            </li>
          </ul>
        </div>

        <a class="complete-btn" *ngIf="nextStep" [routerLink]="nextStep.link">
          Complete Your Profile <i class="fa-solid fa-chevron-right"></i>
        </a>
      </div>
    </aside>

  </section>
</main>
